<template>
  <div
    id="layout"
    class="LayoutHub h-svh w-full flex flex-col mx-auto bg-capino-light overflow-auto"
  >
    <HubHeader v-if="isHubHeaderVisible" />

    <router-view />
  </div>
</template>

<script>
import HubHeader from '@/components/Hub/HubHeader.vue'

export default {
  name: 'LayoutHub',

  components: { HubHeader },

  computed: {
    isHubHeaderVisible() {
      return ['hub.sections'].includes(this.$route.name)
    }
  }
}
</script>
